<template>
  <div class="mainBusiness mainBusiness-mac">
    <header>
      <div class="main">
        <!-- <img
          src="../assets/img/buliding/建筑智能化_banner@2x.png"
          class="banner"
        /> -->
        <img
          src="../assets/img/buliding/建筑智能化_智能安防1@2x.jpeg"
          class="banner"
        />
        <div class="left"></div>
        <div class="center">
          <div class="title">
            <h1>城市与建筑智能化</h1>
            <span></span>
            <p class="buildingText" style="font-weight: 700;max-width: 2000px;">
              城市与建筑智能化是一个跨学科、多层次的概念，其核心目标是通过先进的信息技术和数据分析手段，提高城市与建筑的运营效率，改善民众的生活质量。城市与建筑智能化不仅仅是硬件与软件的升级，更是一种综合性的解决方案，使用了包括但不限于物联网（IoT）技术、大数据分析、云计算和人工智能决策等。
              根据不同的需求与场景，城市与建筑智能化的建设/改造，包括但不限于以下的内容：安防监控，停车场管理，门禁管理，道闸管理，综合布线，楼宇自动化控制，广播管理，计算机系统管理，综合物业管理，中央空调管理，应急管理，计算机机房管理，车流管理，人流管理，给排水等
            </p>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </header>

    <main>
      <div class="main">
        <div class="main-background1"></div>
        <div class="background2f"><div class="main-background2"></div></div>
        <div class="main-background3"></div>
        <div class="left"></div>
        <div class="center">
          <div class="main1">
            <div class="main1-left">
              <!-- <img
                src="../assets/img/buliding/建筑智能化_智能安防1@2x.jpeg"
                alt=""
              /> -->
              <img src="../assets/img/buliding/城市智能化1.png" alt="" />
            </div>
            <div class="main1-right">
              <div class="main-text">
                <!-- <h1>智能安防</h1> -->
                <!-- <p>
                  智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。智能安防与传统安防的最大区别在于智能化，我国安防产业发展很快，也比较普及，但是传统安防对人的依赖性比强，非常耗费人力，而智能安防能够通过机器实现智能判断，从而尽可能实现人想做的事。
                </p> -->
                <h1>城市智能化</h1>
                <p>
                  涵盖了所有以行政区域（省/市/县/区等）为层级的智能化建设/改造业务，包括但不限于地铁站，道路监测，公共停车场，水利，林业，农业等；在此业务线中，昌恩较有代表性的案例有广东省和平县公安局交通警察大队电子警察系统工程
                  、福田区天健商务大厦停车场
                  、深圳坪山新区燕子岭配套员工宿舍停车场、宝安区福永文化中心地下停车场、宝安沙井新桥村民住宅统建楼停车场、广东梅州幸福家园地下停车场、浙江省东阳市老公安局智能停车场等。
                </p>
                <!-- <button>
                  <router-link :to="{ path: '/security' }">
                    <span>查看更多</span>
                    <img
                      class="rightimg"
                      src="../assets/img/buliding/icon_more@2x.png"
                      alt=""
                    />
                  </router-link>
                </button> -->
              </div>
              <div class="trimg">
                <img
                  src="../assets/img/buliding/建筑智能化_智能安防2@2x.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div class="main2">
            <div class="main2-left">
              <div class="main-text">
                <!-- <h1>建筑智能化</h1>
                <p>
                  智能建筑是一个发展中的概念，它随着科学技术的进步和人们对其功能要求的变化而不断更新、补充内容。<br />
                  在通常的设计当中，我把建筑智能化分为三个大系统：安全防范系统、通信及控制系统、多媒体系统。每个大系统内又包含了诸多的子系统，这与一些设计规范有点出入。
                </p> -->
                <h1>园区智能化</h1>
                <p>
                  涵盖了一切有明确范围边界，由多个设施或建筑汇集形成的园区下的智能化建设/改造业务，包括但不限于大型医院，大型校园，工业园，产业园，科技园，保税区等；在此业务线中，昌恩较有代表性的案例有：前海人寿广州总医院、龙岗区人民医院健康管理中心大楼、深圳市宝安区中心医院、深圳市第二人民医院、贵州贵安职业学院、深圳职业技术学院、深圳松岗中学、西乡中学、华侨城中学、深圳劲嘉工业园、青岛嘉颐泽工业园、中丰田光电（珠海）工业园、深圳大百汇高新技术产业园等。
                </p>

                <!-- <button>
                  <router-link :to="{ path: '/traffic4' }">
                    <span>查看更多</span>
                    <img
                      class="rightimg"
                      src="../assets/img/buliding/icon_more@2x.png"
                      alt=""
                    />
                  </router-link>
                </button> -->
              </div>
            </div>
            <div class="main2-right">
              <div class="dimg1">
                <img
                  src="../assets/img/buliding/建筑智能化_建筑智能化1@2x.jpeg"
                  alt=""
                  class="img1"
                />
              </div>
              <div class="main2-box">
                <div class="dimg2">
                  <img
                    src="../assets/img/buliding/建筑智能化_建筑智能化2@2x.png"
                    alt=""
                    class="img2"
                  />
                </div>
                <div class="dimg3">
                  <img
                    src="../assets/img/buliding/建筑智能化_建筑智能化3@2x.png"
                    alt=""
                    class="img3"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="main3">
            <div class="main3-left">
              <div class="dimg4" style="padding: 0 16px">
                <img
                  src="../assets/img/buliding/建筑智能化_中央空调系统1@2x.jpg"
                  alt=""
                  style="object-fit: cover;"
                />
              </div>
              <!-- <div class="main3-box">
                <div class="dimg5">
                  <img
                    src="../assets/img/buliding/建筑智能化_中央空调系统2@2x.png"
                    alt=""
                  />
                </div>
                <div class="dimg6">
                  <img
                    src="../assets/img/buliding/建筑智能化_中央空调系统3@2x.png"
                    alt=""
                  />
                </div>
              </div> -->
              <div class="main3-box">
                <div class="dimg6">
                  <img
                    src="../assets/img/buliding/建筑智能化_中央空调系统2@2x.png"
                    alt=""
                  />
                </div>

                <div class="dimg5">
                  <img
                    src="../assets/img/buliding/建筑智能化_中央空调系统3@2x.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="main3-right">
              <div class="main-text">
                <!-- <h1>中央空调节能系统</h1>
                <p>
                  中央空调恒温节能控制系统是由变频器、温度传感器、压力传感器、可编程控制器(PLC)以及人机界面等几部分组成。它根据空调系统需要控制部位的参数(如冷却水温度等),由PLC来控制调整冷却水电机、冷冻水电机等机组动力单元的运行状态,在精确进行温度控制的同时,大幅度的节约了电能。
                </p> -->
                <h1>建筑智能化</h1>
                <p>
                  涵盖了单一楼宇内的所有智能化与机电的建设/改造业务，包括但不限于写字楼，居民楼，海关关口，博物馆，美术馆，银行等；在此业务线中，昌恩较有代表性的案例有：上海建滔广场、中铁海南诺德丽湖半岛酒店、深汕合作区海洋产业研发中心酒店、
                  文锦渡海关、贵州武警总队、大百汇广场、河南平顶山市博物馆、上海银行深圳分行、平安银行厦门分行、东莞银行总行等。
                </p>
                <!-- <button>
                  <router-link :to="{ path: '/air' }">
                    <span class="rightimg"> 查看更多</span>
                    <img src="../assets/img/buliding/icon_more@2x.png" alt="" />
                  </router-link>
                </button> -->
              </div>
            </div>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </main>

    <div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  name: "buliding",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
@media screen and (min-width: 1200px) and (max-width: 1600px) {
  .main-background1 {
    height: 480px !important;
  }
  .mainBusiness .main-background2 {
    top: 800px !important;
    height: 740px;
  }
  .center .main2 {
    margin-top: 80px;
  }
  .mainBusiness .main-background3 {
    top: 1640px;
  }
  .mainBusiness .main2 {
    margin-top: 60px;
  }
  .mainBusiness .main3 {
    margin-top: -60px;
  }
}
/* 150% */
@media screen and (max-width: 1285px) {
  .main1 {
    margin-left: -100px;
    transform: scale(0.76);
  }
  .main1-left {
    width: 1000px !important;
  }
  .main1-right {
    width: 500px !important;
  }
  /* 主营业务--智能建筑化 */
  .mainBusiness .main2 {
    transform: scale(0.76);
    /* margin-top: -10px !important; */
  }

  /* 主营业务--智能建筑化 */
  .mainBusiness .main3 {
    transform: scale(0.76);
    /* margin-top: -10px !important; */
  }
  .mainBusiness .main {
    height: 2430px;
  }

  .main-background1 {
    height: 440px !important;
    /* background-color: black; */
  }

  .mainBusiness .main-background2 {
    top: 740px !important;
    height: 610px;
    /* background-color: red; */
  }

  .mainBusiness .main2 {
    margin-top: -60px;
    /* background-color: pink; */
  }
  .mainBusiness .main3 {
    margin-top: -160px;
    /* background-color: purple; */
  }
  .mainBusiness .main-background3 {
    height: 700px !important;
    top: 1440px;
  }
  .mainBusiness .main {
    height: 2000px;
  }
}

/* 缩放175% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1199px) {
  .main1 {
    transform: scale(0.86);
    width: 1200px !important;
    margin-left: -180px;
  }
  .main-background1 {
    width: 1600px !important;
    margin-left: -200px;
  }
  /*主营业务-- 建筑智能化 */
  .mainBusiness .main {
    height: 2330px;
  }
  .mainBusiness .main-background3 {
    height: 600px !important;
  }

  .mainBusiness .main-background1 {
    height: 470px !important;
  }

  .mainBusiness .main-background2 {
    top: 780px !important;
    height: 640px;
    /* background-color: red; */
  }
  .mainBusiness .main1 {
    margin-top: 60px !important;
  }
  .mainBusiness .main2 {
    margin-top: 0px;
  }
  .mainBusiness .main3 {
    margin-top: 30px;
  }
  .mainBusiness .main-background3 {
    height: 520px !important;
    top: 1460px;
    /* background-color: orange; */
  }
  .mainBusiness .main {
    height: 1900px;
  }
}

/* 缩放200% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1000px) {
  .main1 {
    transform: scale(0.74);
    width: 1200px !important;
    margin-left: -220px;
  }

  /* 主营业务--智能建筑化 */
  .mainBusiness .center .title p {
    width: 900px;
  }

  /* 主营业务--智能建筑化 */
  .mainBusiness .main1 {
    transform: scale(0.7);
    margin-top: -240px !important;
  }

  /* 主营业务--智能建筑化 */
  .mainBusiness .main2 {
    transform: scale(0.7);
  }

  /* 主营业务--智能建筑化 */
  .mainBusiness .main3 {
    transform: scale(0.7);
  }
  /* 主营业务--建筑智能管理 */
  .building-intelligent-management .main1 {
    transform: scale(0.9);
  }

  /* 主营业务--建筑智能管理 */
  .building-intelligent-management .main2 {
    transform: scale(0.96);
  }

  /* 主营业务--建筑智能管理 */
  .building-intelligent-management .main3 {
    transform: scale(0.96);
  }

  /* 主营业务--建筑智能管理 */
  .building-intelligent-management .main4 {
    transform: scale(0.96);
  }
  .mainBusiness .main1 {
    margin-top: 10px !important;
  }
}
@media screen and (max-width: 1260px) {
  body main {
    margin-top: -200px;
    transform: scale(0.8);
    margin-bottom: 0;
  }
}

.trimg {
  height: 232px;
  width: 812px;
  padding: 0 16px;
}

header {
  height: 500px;
  background-color: rgba(40, 53, 72, 0.6);
}
header .banner {
  background: url(../assets/img/buliding/建筑智能化_banner@2x.png) no-repeat;
  /* background-size: 100% 100%; */
  object-fit: cover;
}
header .title {
  position: absolute;
  top: 172px;
  /* z-index: -1; */
  z-index: 2;
}
header .title h1 {
  font-size: 48px;
  letter-spacing: 12px;
  line-height: 65px;
  color: #ffffff;
}
header .title span {
  margin: 34px auto;
  width: 619px;
  height: 1px;
  border: 1px solid;
  border-image: linear-gradient(
      90deg,
      rgba(255, 166, 3, 0),
      rgba(255, 166, 3, 1),
      rgba(255, 166, 3, 0)
    )
    2 2;
}
header .title p {
  /* width: 1000px; */ /*测试恢复*/
  padding: 0 280px; /*测试删除*/
  height: 80px;
  font-size: 16px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 1px;
  margin: 0 auto;
  opacity: 1;
  font-family: PingFangSC-Regular, PingFang SC;
}
.buildingText {
  font-weight: 600;
}
main {
  position: relative;
  margin-bottom: 100px;
}
.main-background1 {
  position: absolute;
  top: 227px;
  width: 100%;
  /* height: 573px; */
  height: 520px;
  background-color: #f5f6fb;
  border-radius: 0.9984px;
  z-index: -1;
}
.main-background2 {
  position: absolute;
  /* top: 900px; */
  top: 840px;
  width: 100%;
  left: 50%;
  margin-left: -290px;
  right: 0px;
  height: 800px;
  background-color: #f5f6fb;
  border-radius: 0.9984px;
  z-index: -1;
}
.main-background3 {
  position: absolute;
  /* top: 1800px; */
  top: 1740px;
  width: 100%;
  height: 800px;
  background-color: #f5f6fb;
  border-radius: 0.9984px;
  z-index: -1;
}
.main1 {
  width: 100%;
  margin-top: 80px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.main1-left {
  width: 752px;
  height: 668px;
  /* overflow: hidden; */
  padding-top: 10px;
}
.main1-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main1-right .main-text {
  margin-left: 15px;
  width: 780px;
  /* height: 523px; */
  height: 408px;
}
<!-- .main1-right img {
  margin-left: 44px;
  width: 540px;
}
-- > .maintext .rightimg {
  margin-left: 25px !important;
}
.main-text {
  padding: 0 60px;
  margin-bottom: 16px;
  margin-left: -110px;
  /* width: 594px; */
  width: 640px;
  height: 523px;
  background: #ffffff;
  box-shadow: 0rem 0.9984px 10px 0rem rgba(176, 183, 213, 0.2);
}

.main-text h1 {
  padding-top: 54px;
  margin-bottom: 33px;
  font-size: 38px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 2px;
}
.main1-right .main-text p {
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 40px;
  letter-spacing: 1px;
}
button a {
  color: #140047;
}
.main-text p {
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 40px;
  letter-spacing: 0.72px;
}
.main1-right .main-text button {
  display: flex;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  color: #140047;
  transition: margin-left 0.3s;
  cursor: pointer;
}
.main-text button {
  display: flex;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  color: #140047;
  transition: margin-left 0.3s;
  cursor: pointer;
}
.main3-right {
  margin-bottom: 29px;
  margin-left: 100px;
}
.main3-right .main-text button {
  display: flex;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  color: #140047;
  transition: margin-left 0.3s;
  cursor: pointer;
}
.main-text button:hover {
  margin-left: 10.0032px;
}
.main-text button span {
  margin-right: 40px;
  font-weight: 600;
  line-height: 24px;
  font-size: 18px;
}
.main-text button img {
  width: 18px;
  height: 10px;
  margin-left: 25px;
}
.main1-right img {
  width: 100%;
  height: 100%;
}
.main2 {
  width: 100%;
  /* margin-top: 180px; */
  margin-top: 120px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.main2-left {
  margin-top: 140px;
}
.main2-left .main-text {
  /* width: 714px; */
  width: 720px;
  /* height: 533px; */
  height: 618px;
  /* margin-bottom: 20px; */
}
.main2-right {
  display: flex;
  margin-left: 36px;
}
.main2-box {
  width: 354px;
}
.dimg1 {
  height: 655px;
  width: 364px;
  object-fit: cover;
}
.main2-right .img1 {
  height: 100%;
  width: 100%;
  object-fit: cover;
  padding: 20px 20px 16px;
}
.dimg2 {
  height: 460px;
  width: 454px;
  padding: 20px 0 30px;
}

.main2-right .img2 {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.dimg3 {
  height: 192px;
  width: 454px;
  padding: 0px 0 10px 0;
  overflow: hidden;
  margin-top: -14px;
}
.main2-right .img3 {
  height: 100%px;
  width: 100%;
}
.main3 {
  padding-top: 280px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  /* background-color: black; */
}
.main3-left {
  margin-right: 15px;
}
.main3-left img {
  width: 676px;
  height: 375px;
  object-fit: cover;
  margin-top: -34px;
}
.main3-box {
  display: flex;
  justify-content: space-between;
}
/* <!-- .main3-box img:nth-child(1) {
  width: 223px;
  height: 232px;
  object-fit: cover;
}
.main3-box img:nth-child(2) {
  width: 453px;
  height: 232px;
  object-fit: cover;
}
-- >  */

.main3-right {
  height: 590px;
}
.main3-right .main-text {
  width: 483pxpx;
  /* margin-bottom: 29px; */
  /* height: 425px; */
  /* height: 590px; */
  height: 100%;
  margin-top: -6px;
}
.dimg4 {
  /* width: 938px; */
  width: 618px;
  height: 375px;
}
.dimg5 {
  width: 286px;
  height: 590px;
  /* height: 232px; */
  /* overflow: hidden; */
  /* padding-left: 16px; */
  margin-top: -374px;
  padding-right: 16px;
}
.dimg5 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dimg6 {
  /* width: 650px; */
  width: 618px;
  height: 232px;
  overflow: hidden;
  padding: 0 16px;
  margin-top: -16px;
}
.dimg6 img {
  width: 100%;
  height: 100%;
  object-position: bottom;
  object-fit: cover;
}
.dimg5 img {
  width: 100%;
  height: 100%;
}
.dimg4 img {
  width: 100%;
  height: 100%;
}
img {
  border: 1px dashed #808080;
}
p {
  opacity: 0.72;
}
</style>



// WEBPACK FOOTER //
// src/components/buliding.vue